import initialState from './initial';
import { AFFILIATES_GET, AFFILIATES_GET_DETAILS, AFFILIATE_GET, AFFILIATE_GET_DETAILS } from '../constants/affiliates';

const AffiliateReducer = (state = initialState.affiliates, action) => {
    const { type, payload } = action;
    switch (type) {
        case AFFILIATES_GET:
        case AFFILIATES_GET_DETAILS: {
            const { affiliates } = payload;
            return { ...affiliates };
        }

        case AFFILIATE_GET:
        case AFFILIATE_GET_DETAILS: {
            const { affiliate } = payload;
            return { ...affiliate };
        }

        default:
            return state;
    }
};
export default AffiliateReducer;
